export default __webpack_public_path__ + "static/media/logo-inowas.3bcee882.svg";